/* eslint-disable array-callback-return */
import React from 'react';
import { ModelSetLayer } from './ModelSetLayer';
import { CustomLayer } from './CustomLayer';

class NoiseLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            List:[]
        };
    }
    componentDidMount(){
        let List = window.LAYER_GROUP_NOISEMAP.LAYER;
        this.setState({List:List});
    }
    render(){
        const List = this.state.List;
        const deleteList = this.props.deleteList;
        return( 
            <div className="ts checkboxes">
                {
                    List.map(
                        (layer,index)=>
                        {
                            switch(layer.TYPE){
                                case "ModelSet":
                                    return <ModelSetLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList} setinfoBox={(attr)=>this.props.setinfoBox(attr)} setinfoBoxOpen = {this.props.setinfoBoxOpen} setLegendBoxSwitch={this.props.setLegendBoxSwitch} setLegendBoxContent={this.props.setLegendBoxContent} setTimeLineContent = {this.props.setTimeLineContent} currentTime={this.props.currentTime}/>;
                                case "Custom":
                                    return <CustomLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList} setinfoBox={(attr)=>this.props.setinfoBox(attr)} setLegendBoxSwitch={this.props.setLegendBoxSwitch} setLegendBoxContent={this.props.setLegendBoxContent} setTimeLineContent = {this.props.setTimeLineContent} currentTime={this.props.currentTime}/>;

                                default:
                                    break;
                            }
                        }
                    )
                }
            </div>           
        );
    }
}

export default NoiseLayer;